import modules_select from './select/index.js'
import modules_item from './item/index.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    modules:{
        item: modules_item,
        select: modules_select,
    },
}